import './App.css';
import React, { useState } from 'react';
import ApiContext from './ApiContext';
import VideoGallery from './VideoGallery';

const App = () => {
    const apiUrl = 'https://qn1vwd4tuk.execute-api.eu-west-1.amazonaws.com/production';
    const [apiData] = useState(null);
    const [viewMode, setViewMode] = useState(new URLSearchParams(window.location.search).get('view') === 'archiv' ? 'archiv' : 'aktuell');

    return (
        <ApiContext.Provider value={{ baseUrl: apiUrl, data: apiData }}>
            <div className="App">
                <header className="App-header">
                    <img className="header-image" src="title.png" alt="Riesenstein Videocloud" />
                    <div className="view-switch">
                        <button className={viewMode === 'aktuell' ? 'active' : ''} onClick={() => setViewMode('aktuell')}>Aktuell</button>
                        <button className={viewMode === 'archiv' ? 'active' : ''} onClick={() => setViewMode('archiv')}>Archiv</button>
                        <a className="live-tab" href="https://live.tauchbasis-riesenstein.com/" target="_blank" rel="noreferrer">Live-Kamera</a>
                    </div>
                    <div className="legal-header">
                        <a href="https://www.tauchbasis-riesenstein.com/leere-seite-2">Datenschutz</a>
                        <a href="https://www.tauchbasis-riesenstein.com/leere-seite-1">Impressum</a>
                    </div>
                </header>
                <main>
                    <VideoGallery viewMode={viewMode} setViewMode={setViewMode} />
                </main>
            </div>
        </ApiContext.Provider>
    );
};

export default App;
